export const PROP_POSTER_FILTER = 'INF_Picking';
